import {Component, Input} from '@angular/core';
import {FormBuilder} from '@angular/forms';
import {SelectConfig} from '../../model/select-config';

@Component({
  selector: 'nc-checkbox-cell-header',
  templateUrl: './nc-checkbox-cell-header.component.html',
  styleUrls: ['./nc-checkbox-cell-header.component.scss'],
})
export class NcCheckboxCellHeaderComponent {
  @Input() selectConfig: SelectConfig;
  @Input() data: any[];

  constructor(private formBuilder: FormBuilder) {
  }

  isAllSelected = (): boolean => {
    const numberOfSelected = this.selectConfig !== null ? this.selectConfig.formArray.getRawValue().length : 0;
    return  numberOfSelected === this.data.filter(x => x.file === undefined || x.file === null).length;
  }

  selectAll = (): void => {
    this.selectConfig.formArray.clear();
    this.data.forEach(item => {
      if (item.file === undefined || item.file === null) {
        const selectedItem = this.formBuilder.group({value: [item[this.selectConfig.identifierColumn]]});
        this.selectConfig.formArray.push(selectedItem);
      }
    });
  }

  deselectAll = (): void => {
   this.selectConfig.formArray.clear();
  }
}
